import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import FrontLayout from '@/frontLayout'

export const constantRoutes = [
  {
    path: '/',
    component: FrontLayout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/home/index'),
        meta: { title: 'Home' },
        hidden: true
      }
    ]
  },
  {
    path: '/article',
    component: FrontLayout,
    children: [
      {
        path: '/article',
        component: () => import('@/views/article/index'),
        meta: { title: 'Article' },
        hidden: true
      }
    ]
  },
  {
    path: '/consortia',
    component: FrontLayout,
    children: [
      {
        path: '/consortia',
        component: () => import('@/views/consortia/index'),
        meta: { title: 'Consortia' },
        hidden: true
      }
    ]
  },
  {
    path: '/conference',
    component: FrontLayout,
    children: [
      {
        path: '/conference',
        component: () => import('@/views/conference/index'),
        meta: { title: 'Conference' },
        hidden: true
      }
    ]
  },
  {
    path: '/conf',
    component: FrontLayout,
    children: [
      {
        path: '/conf',
        component: () => import('@/views/conf/summercamp2025/index'),
        meta: { title: 'Summer Camp 2025' },
        hidden: true
      }
    ]
  },
  {
    path: '/conf/bigbrain',
    component: FrontLayout,
    children: [
      {
        path: '/conf/bigbrain',
        component: () => import('@/views/conf/bigbrain/index'),
        meta: { title: 'Big Brain Conference' },
        hidden: true
      }
    ]
  },
  {
    path: '/conf/xishuangbanna',
    component: FrontLayout,
    children: [
      {
        path: '/conf/xishuangbanna',
        component: () => import('@/views/conf/xishuangbanna/index'),
        meta: { title: 'xishuangbanna' },
        hidden: true
      }
    ]
  },
  {
    path: '/conf/summer',
    component: FrontLayout,
    children: [
      {
        path: '/conf/summer',
        component: () => import('@/views/conf/summercamp/index'),
        meta: { title: 'Summer Camp 2022' },
        hidden: true
      },
      {
        path: '/conf/summer2025',
        component: () => import('@/views/conf/summercamp2025/index'),
        meta: { title: 'Summer Camp 2025' },
        hidden: true
      },
      {
        path: '/conf/summer2024',
        component: () => import('@/views/conf/summercamp2024/index'),
        meta: { title: 'Summer Camp 2024' },
        hidden: true
      },
      {
        path: '/conf/summer2023',
        component: () => import('@/views/conf/summer2023/index'),
        meta: { title: 'Summer Camp 2023' },
        hidden: true
      }
    ]
  },
  {
    path: '/conf/summer2023',
    component: FrontLayout,
    children: [
      {
        path: '/conf/summer2023',
        component: () => import('@/views/conf/summer2023/index'),
        meta: { title: 'Summer Camp 2023' },
        hidden: true
      }
    ]
  },
  {
    path: '/software',
    component: FrontLayout,
    children: [
      {
        path: '/software',
        component: () => import('@/views/software/index'),
        meta: { title: 'Software' },
        hidden: true
      }
    ]
  },
  {
    path: '/database',
    component: FrontLayout,
    children: [
      {
        path: '/database',
        component: () => import('@/views/database/index'),
        meta: { title: 'Database' },
        hidden: true
      }
    ]
  },
  {
    path: '/people',
    component: FrontLayout,
    children: [
      {
        path: '/people',
        component: () => import('@/views/people/index'),
        meta: { title: 'People' },
        hidden: true
      }
    ]
  },
  {
    path: '/people/detail',
    name: 'people.detail',
    component: FrontLayout,
    children: [
      {
        path: '/people/detail',
        component: () => import('@/views/people/detail'),
        meta: { title: 'People Detail' },
        hidden: true
      }
    ]
  },
  {
    path: '/news',
    component: FrontLayout,
    children: [
      {
        path: '/news',
        component: () => import('@/views/news/index'),
        meta: { title: 'News' },
        hidden: true
      }
    ]
  },
  {
    path: '/news/detail',
    name: 'news.detail',
    component: FrontLayout,
    children: [
      {
        path: '/news/detail',
        component: () => import('@/views/news/detail'),
        meta: { title: 'News Detail' },
        hidden: true
      }
    ]
  },
  {
    path: '/about',
    component: FrontLayout,
    children: [
      {
        path: '/about',
        component: () => import('@/views/about/index'),
        meta: { title: 'About' },
        hidden: true
      }
    ]
  },
  {
    path: '/about/data',
    component: FrontLayout,
    children: [
      {
        path: '/about/data',
        component: () => import('@/views/about/data'),
        meta: { title: 'Data' },
        hidden: true
      }
    ]
  },
  {
    path: '/login',
    component: FrontLayout,
    children: [
      {
        path: '/login',
        component: () => import('@/views/login/index'),
        meta: { title: 'Login' },
        hidden: true
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },

  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/dashboard',
  //       component: () => import('@/views/dashboard/index'),
  //       name: 'Dashboard',
  //       meta: { title: 'Dashboard', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/profile',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/profile',
  //       component: () => import('@/views/profile/index'),
  //       name: 'Profile',
  //       hidden: true,
  //       meta: { title: 'Profile' }
  //     }
  //   ]
  // }
]

// export const asyncRoutes = [
//   {
//     path: '/admin/people',
//     component: Layout,
//     redirect: '/admin/people/create',
//     meta: { title: 'Personnel', icon: 'peoples', roles: ['admin', 'editor'], affix: true },
//     children: [
//       {
//         path: '/admin/people/list',
//         component: () => import('@/views/people/list'),
//         meta: { title: 'People List', icon: 'list', roles: ['admin'], affix: true }
//       },
//       {
//         path: '/admin/people/create',
//         component: () => import('@/views/people/create'),
//         meta: { title: 'Create People', icon: 'list', roles: ['admin'] }
//       },
//       {
//         path: '/admin/people/edit',
//         component: () => import('@/views/people/edit'),
//         hidden: true,
//         meta: { title: 'Edit People', icon: 'edit', roles: ['admin', 'editor'], activeMenu: '/admin/people/list' }
//       }
//     ]
//   },
//   {
//     path: '/admin/article',
//     component: Layout,
//     redirect: '/admin/article/list',
//     meta: { title: 'Article', icon: 'documentation', roles: ['admin'] },
//     children: [
//       {
//         path: '/admin/article/list',
//         component: () => import('@/views/article/list'),
//         meta: { title: 'Article List', icon: 'list', roles: ['admin'] }
//       },
//       {
//         path: '/admin/article/create',
//         component: () => import('@/views/article/create'),
//         meta: { title: 'Create Article', icon: 'list', roles: ['admin'] }
//       },
//       {
//         path: '/admin/article/edit',
//         component: () => import('@/views/article/edit'),
//         hidden: true,
//         meta: { title: 'Edit Article', icon: 'edit', roles: ['admin'], activeMenu: '/admin/article/list' }
//       }
//     ]
//   },
//   {
//     path: '/admin/software',
//     component: Layout,
//     redirect: '/admin/software/list',
//     meta: { title: 'Software', icon: 'example', roles: ['admin'] },
//     children: [
//       {
//         path: '/admin/software/list',
//         component: () => import('@/views/software/list'),
//         meta: { title: 'Software List', icon: 'list', roles: ['admin'] }
//       },
//       {
//         path: '/admin/software/create',
//         component: () => import('@/views/software/create'),
//         meta: { title: 'Create Software', icon: 'list', roles: ['admin'] }
//       },
//       {
//         path: '/admin/software/edit',
//         component: () => import('@/views/software/edit'),
//         hidden: true,
//         meta: { title: 'Edit Software', icon: 'edit', roles: ['admin'], activeMenu: '/admin/software/list' }
//       }
//     ]
//   },
//   {
//     path: '/admin/resource',
//     component: Layout,
//     redirect: '/admin/resource/list',
//     meta: { title: 'PGG Resource', icon: 'component', roles: ['admin', 'editor'] },
//     children: [
//       {
//         path: '/admin/resource/list',
//         component: () => import('@/views/resource/list'),
//         meta: { title: 'PGG Resource List', icon: 'component', roles: ['admin', 'editor'] }
//       },
//       {
//         path: '/admin/resource/create',
//         component: () => import('@/views/resource/create'),
//         meta: { title: 'Create Resource', icon: 'list', roles: ['admin'] }
//       },
//       {
//         path: '/admin/resource/edit',
//         component: () => import('@/views/resource/edit'),
//         hidden: true,
//         meta: { title: 'Edit Resource', icon: 'edit', roles: ['admin'], activeMenu: '/admin/resource/list' }
//       }
//     ]
//   },
//   {
//     path: '/admin/news',
//     component: Layout,
//     redirect: '/admin/news/list',
//     meta: { title: 'News', icon: 'message', roles: ['admin'] },
//     children: [
//       {
//         path: '/admin/news/list',
//         component: () => import('@/views/news/list'),
//         meta: { title: 'News List', icon: 'edit', roles: ['admin'] }
//       },
//       {
//         path: '/admin/news/create',
//         component: () => import('@/views/news/create'),
//         meta: { title: 'Create News', icon: 'list', roles: ['admin'] }
//       },
//       {
//         path: '/admin/news/edit',
//         component: () => import('@/views/news/edit'),
//         hidden: true,
//         meta: { title: 'Edit News', icon: 'list', roles: ['admin'], activeMenu: '/admin/news/list' }
//       }
//     ]
//   },
//   {
//     path: '/admin/meeting',
//     component: Layout,
//     redirect: '/admin/meeting/list',
//     meta: { title: 'Group Meeting', icon: 'clipboard', roles: ['admin', 'editor'] },
//     children: [
//       {
//         path: '/admin/meeting/list',
//         component: () => import('@/views/meeting/list'),
//         meta: { title: 'Meeting List', icon: 'clipboard', roles: ['admin', 'editor'] }
//       },
//       {
//         path: '/admin/meeting/create',
//         component: () => import('@/views/meeting/create'),
//         meta: { title: 'Create Meeting', icon: 'edit', roles: ['admin'] }
//       },
//       {
//         path: '/admin/meeting/detail',
//         component: () => import('@/views/meeting/detail'),
//         hidden: true,
//         meta: { title: 'Meeting Detail', icon: 'edit' }
//       },
//       {
//         path: '/admin/meeting/edit',
//         component: () => import('@/views/meeting/edit'),
//         hidden: true,
//         meta: { title: 'Edit Meeting', icon: 'edit', roles: ['admin'], activeMenu: '/admin/meeting/list' }
//       }
//     ]
//   },
//   // {
//   //   path: '/admin/resource',
//   //   component: Layout,
//   //   redirect: '/admin/resource/list',
//   //   meta: { title: 'Resource', icon: 'table', roles: ['admin'] },
//   //   children: [
//   //     {
//   //       path: '/admin/resource/list',
//   //       component: () => import('@/views/resource/list'),
//   //       meta: { title: 'Resource List', icon: 'edit', roles: ['admin'] }
//   //     },
//   //     {
//   //       path: '/admin/resource/create',
//   //       component: () => import('@/views/resource/create'),
//   //       meta: { title: 'Create Resource', icon: 'list', roles: ['admin'] }
//   //     }
//   //   ]
//   // },
//   {
//     path: '/admin/notification',
//     component: Layout,
//     redirect: '/admin/notification/list',
//     meta: { title: 'Notification', icon: 'guide', roles: ['admin', 'editor'] },
//     children: [
//       {
//         path: '/admin/notification/list',
//         component: () => import('@/views/notification/list'),
//         meta: { title: 'Notification List', icon: 'guide', roles: ['admin', 'editor'] }
//       },
//       {
//         path: '/admin/notification/create',
//         component: () => import('@/views/notification/create'),
//         meta: { title: 'Create Notification', icon: 'edit', roles: ['admin'] }
//       },
//       {
//         path: '/admin/notification/edit',
//         component: () => import('@/views/notification/edit'),
//         hidden: true,
//         meta: { title: 'Edit Notification', icon: 'edit', roles: ['admin'] }
//       }
//     ]
//   },
//   { path: '*', redirect: '/404', hidden: true }
// ]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
